import { connect } from 'react-redux';
import { getDesign, searchIssues } from '../../redux/actions/app.js';
import Issues from './screen.js';



const mapStateToProps = (state) => ({
    issues: state.app,
    // designData: state.app.designData,
});

const mapDispatchToProps = (dispatch) => ({
    searchIssues: crnId => dispatch(searchIssues(crnId))
});

const IssuesContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export default IssuesContainer(Issues);